var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"click"}},[_c('button',{class:[ _vm.ancho ? 'ancho' : 'largo' ],attrs:{"type":"button","disabled":_vm.disabled}},[_vm._v(_vm._s(_vm.buttonText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }